import _ from 'lodash'
import queryString from 'query-string'

function convertParamsToUrl(urlParams, options, href = undefined) {
  const currentUrl = href || window.location.href
  let parsedUrl = queryString.parseUrl(currentUrl, { arrayFormat: 'comma', parseFragmentIdentifier: true, ...options })
  const { query = {}, ...restOptions } = urlParams
  const { query: currentQuery, ...currentRestOptions } = parsedUrl

  const wholeQueryParams = { ...currentQuery, ...query }

  const filteredQueryParams = _(wholeQueryParams)
    .toPairs()
    .filter(([, itemValue]) => itemValue !== '' || itemValue.length !== 0)
    .fromPairs()
    .value()

  parsedUrl = {
    ...currentRestOptions,
    query: filteredQueryParams,
    ...restOptions
  }
  return queryString.stringifyUrl(parsedUrl, { arrayFormat: 'comma', parseFragmentIdentifier: true, encode: true, ...options })
}

function updateUrlWithParams(urlParams, options = {}, href = undefined) /* istanbul ignore next */ {
  const newUrlWithParams = convertParamsToUrl(urlParams, options, href)

  window.history.replaceState('newUrl', '', newUrlWithParams)
  return newUrlWithParams
}

const mappingUrlParams = (originUrlParams, urlParamsMapping) => {
  const { grouping, keyOrder, ...restParams } = originUrlParams
  const mappedGrouping = urlParamsMapping.grouping[grouping] || grouping
  const keyOrderArray = keyOrder ? (Array.isArray(keyOrder) ? keyOrder : [keyOrder]) : []
  const mappedKeyOrder = keyOrderArray?.map((keyOrderItem) => urlParamsMapping.keyOrder[keyOrderItem] || keyOrderItem)
  const mappedParams = _(restParams)
    .toPairs()
    .map((param) => {
      const [key, value] = param
      const newKey = urlParamsMapping.keyOrder[key] || key

      return [newKey, value]
    })
    .fromPairs()
    .value()

  const combinedParams = {
    ...mappedParams,
    ...(grouping ? { grouping: mappedGrouping } : {}),
    ...(keyOrderArray.length ? { keyOrder: mappedKeyOrder } : {})
  }

  if (
    grouping === mappedGrouping &&
    keyOrderArray.join(',') === mappedKeyOrder.join(',') &&
    JSON.stringify(restParams) === JSON.stringify(mappedParams)
  ) {
    return false
  }

  return combinedParams
}

function getLatestUrlParams(options) {
  const { href, keys = undefined, urlParamsMapping } = options || {}
  const currentUrl = href || window.location.href
  const parsedUrl = queryString.parseUrl(currentUrl, { arrayFormat: 'comma' })

  if (urlParamsMapping) {
    const mappedUrlParams = mappingUrlParams(parsedUrl.query, urlParamsMapping)

    if (mappedUrlParams) {
      updateUrlWithParams({ query: mappedUrlParams }, {}, parsedUrl.url)
    }
  }

  return keys && Array.isArray(keys) ? _.pick(parsedUrl.query, keys) : parsedUrl.query
}

function parseQueryString(currentUrl, options) {
  return queryString.parseUrl(currentUrl, { arrayFormat: 'comma', parseFragmentIdentifier: true, ...options })
}

function stringifyQueryString(currentUrl, options) {
  return queryString.stringify(currentUrl, { arrayFormat: 'comma', parseFragmentIdentifier: true, ...options })
}

/* istanbul ignore next */
function setCanonicalUrl(canonicalUrl) /* istanbul ignore next */ {
  const head = document.getElementsByTagName('head')[0]
  const hasCanonicalUrl = document.querySelector("link[rel='canonical']") !== null
  if (head) {
    if (hasCanonicalUrl) {
      head.removeChild(document.querySelector("link[rel='canonical']"))
    }
    if (canonicalUrl) {
      const link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      link.setAttribute('href', `${canonicalUrl}`)
      head.appendChild(link)
    }
  }
}

/* istanbul ignore next */
function updateFundDetailCanonicalUrl(tab = 'overview') /* istanbul ignore next */ {
  const currentTab = tab || 'overview'
  const { pathname, origin } = window.location
  if (currentTab === 'overview') {
    setCanonicalUrl(`${origin}${pathname}`)
  } else {
    setCanonicalUrl('')
  }
}

function updateCanonicalUrl(canonicalUrlMaps = [], location = window.location) {
  let url = ''
  const { pathname, origin } = location
  const matched = canonicalUrlMaps.find(({ key }) => new RegExp(key).test(pathname))
  if (matched && matched.value) {
    url = `${origin}${matched.value}`
    setCanonicalUrl(url)
  }
  return url
}

/* istanbul ignore next */
function removeCanonicalUrl() /* istanbul ignore next */ {
  setCanonicalUrl('')
}

export {
  convertParamsToUrl,
  updateUrlWithParams,
  getLatestUrlParams,
  parseQueryString,
  stringifyQueryString,
  updateFundDetailCanonicalUrl,
  removeCanonicalUrl,
  updateCanonicalUrl
}
